export const LoginState = {
    NONE: "LoginState.NONE",
    MASTERPASSWORD: "LoginState.MASTERPASSWORD",
    ERROR: "LoginState.ERROR",
    LOADING: "LoginState.LOADING",
    SUCCESSFUL: "LoginState.SUCCESSFUL",
    SUCCESSFULWITHERROR: "LoginState.SUCCESSFULWITHERROR",
    WAITING: "LoginState.WAITING"
};